import React from 'react';

const ImageHolderBox = ({ author }) => {
	const fullPath = '/images/' + author.image;
	return (
		<a href={author.link} target='_new'>
			<img
				src={fullPath}
				className='card-img-top img-card'
				alt={author.name}
				title={author.name}
			/>
		</a>
	);
};

export default ImageHolderBox;
